module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_null.2ff5efcf.png";